import { makeStyles } from "@material-ui/core/styles";
import { SsDialogOpenButton } from "components/front/layout/SsDialogOpenButton";
import OrderCourseOptionModal from "components/front/mypage/order/OrderCourseOptionModal";
import { OrderCourseOption } from "interfaces/front/business";
import { useActivation } from "lib/hooks/useActivation";
import { UpdateCourseOptionInput } from "lib/service/client/FrontOrderService";
import { isOnamaeOption } from "lib/sydm2";
import { infoToast } from "lib/toast";
import React, { FC, useState } from "react";
import { OrderDetail } from "interfaces/front/page/mypage/supportPanel";

const OrderCourseOptionsArea: FC<{ orderDetails: OrderDetail[]; canChangeOption: boolean; orderCode: string }> = ({
  orderDetails,
  ...props
}) => {
  const classes = useStyles();
  return (
    <div className={classes.orderCourseOptionArea}>
      {orderDetails.map((orderDetail, index) => (
        <React.Fragment key={`${orderDetail.id}-${index}`}>
          {orderDetails.length > 1 && <div className={classes.orderCourseOptionQuantityHeadline}>{index + 1}個目のオプション</div>}
          <div>
            {orderDetail.order_course_options.map((orderCourseOption, optionIndex) => (
              <div className={classes.orderCourseOptionItem} key={optionIndex}>
                <div className={classes.orderCourseOptionItemTitle}>
                  <p>{orderCourseOption.question}</p>
                </div>
                <div className={classes.orderCourseOptionItemValue}>
                  <OrderCourseOptionValue detailId={orderDetail.id} option={orderCourseOption} {...props} />
                </div>
              </div>
            ))}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
export default OrderCourseOptionsArea;

const OrderCourseOptionValue: FC<{ detailId: number; option: OrderCourseOption; orderCode: string; canChangeOption: boolean }> = ({
  detailId,
  option: optionProp,
  orderCode,
  canChangeOption,
}) => {
  const [isOpen, open, close] = useActivation(false);
  const [option, setOption] = useState<OrderCourseOption>(optionProp);
  return (
    <>
      <div>{option.input_value}</div>
      {canChangeOption && isOnamaeOption(option.question) && (
        <>
          <SsDialogOpenButton label="変更する" onClick={open} margin="10px 0 0" small />
          <OrderCourseOptionModal
            detailId={detailId}
            orderCode={orderCode}
            isOpen={isOpen}
            orderCourseOption={option}
            onClose={close}
            onUpdated={(values: UpdateCourseOptionInput) => {
              close();
              setOption({ ...option, input_value: values.value });
              infoToast(`オプション「${option.question}」を変更しました。`);
            }}
          />
        </>
      )}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  orderCourseOptionArea: {},
  orderCourseOptionQuantityHeadline: {
    margin: "20px 0 10px",
    "&:first-child": {
      margin: "0 0 10px",
    },
  },
  orderCourseOptionItem: {
    // margin: "20px 0 0",
    "&:first-child": {
      margin: "0",
    },
    border: "1px solid #CCC",
    "&:not(:last-child)": {
      borderBottom: "none",
    },
  },
  orderCourseOptionItemTitle: {
    borderBottom: "1px solid #CCC",
    backgroundColor: "#EEE",
    padding: "5px",
    lineHeight: "1.428em",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "13px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "14px",
    },
  },
  orderCourseOptionItemValue: {
    padding: "10px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "15px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "16px",
    },
  },
}));
